import React, { memo } from "react";

import deleticon from "assets/images/deleticon.svg";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

const CancelImmunisationModalComponent = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title="Cancel vaccine"
      width={500}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              width: "100px",
              height: "100px",
              background: "#fff0f0",
              borderRadius: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <img
              src={deleticon}
              alt=""
              style={{ width: "50px", height: "50px" }}
            />
          </div>
          <p
            style={{
              fontSize: "16px",
              color: "#26252c",
              margin: 0,
              fontWeight: 500,
            }}
          >
            Are you sure you want to cancel this vaccine?
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
          <Button
            variant="outline"
            size="large"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Cancelling..." : "Confirm"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export const CancelImmunisationModal = memo(CancelImmunisationModalComponent);
